module.exports = new __parcel__URL__("floor-tom_10.8525c2e8.mp3").toString();